import React, { useEffect, useMemo, useState } from "react";

import CommonButton from "@cayuse/shared-react.components.button";
import Icon from "@cayuse/shared-react.components.icon";
import { Grid } from "semantic-ui-react";

import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { CAYUSE_TYPES } from "globals/constants";
import { useDictionary } from "hooks";
import { findOrganizationById, findUnitById, findPersonById } from "utils";

import {api} from "../../../../../../../services";
import styles from "./styles.css";

const RuleGroup = ({ displayRules, openModalAssignGroupNumber, removeRuleFromGroup }) => {
	const dictionary = useDictionary("simplifiedBuilder.components.RuleGroup");
	const [ customLabels, setCustomLabels ] = useState([]);
	const isOrgFinder = displayRule => displayRule && displayRule.rule &&
        displayRule.rule.cayuseType === CAYUSE_TYPES.ORG_FINDER;

	const isUnitFinder = displayRule => displayRule && displayRule.rule &&
        displayRule.rule.cayuseType === CAYUSE_TYPES.UNIT_FINDER;

	const isPersonFinder = displayRule => displayRule && displayRule.rule &&
		displayRule.rule.cayuseType === CAYUSE_TYPES.PERSON_FINDER;

	const isFundingProgram = displayRule => displayRule && displayRule.rule &&
		displayRule.rule.cayuseType === CAYUSE_TYPES.FUNDING_PROGRAM;

	const isClassificationCode = displayRule => displayRule && displayRule.rule &&
		displayRule.rule.cayuseType === CAYUSE_TYPES.CLASSIFICATION_CODES;

	const fetchCustomLabelsList = useMemo(() => async () => {
		const result = [];
		for (let displayRule of displayRules) {
			if (isOrgFinder(displayRule)) {
				if (displayRule.rule.itemId) {
					try {
						let organization = await findOrganizationById(displayRule.rule.itemId);
						result[displayRule.rule.itemId] = organization.name;
					} catch (e) {
						console.error(e);
					}
				}
			}

			if (isFundingProgram(displayRule)) {
				if (displayRule.rule.itemId) {
					try {
						let organization = await api.fundingPrograms.findById(displayRule.rule.itemId);
						result[displayRule.rule.itemId] = organization.organizationName + " - " + organization.name;
					} catch (e) {
						console.error(e);
					}
				}
			}

			if (isUnitFinder(displayRule)) {
				if (displayRule.rule.itemId) {
					try {
						let unit = await findUnitById(displayRule.rule.itemId);
						result[displayRule.rule.itemId] = unit.name;
					} catch (e) {
						console.error(e);
					}
				}
			}

			if (isPersonFinder(displayRule)) {
				if (displayRule.rule.itemId) {
					try {
						let person = await findPersonById(displayRule.rule.itemId);
						result[displayRule.rule.itemId] = person.fullName;
					} catch (e) {
						console.error(e);
					}
				}
			}

			if (isClassificationCode(displayRule)) {
				if (displayRule.rule.itemId) {
						result[displayRule.rule.itemId] = displayRule.rule.itemId;
				}
			}
		}
		setCustomLabels(result);
	}, [ displayRules ]);

	useEffect(() => {
		fetchCustomLabelsList();
	}, [ fetchCustomLabelsList ]);

	const getItemLabel = rule => {
		const itemText = rule?.rule?.itemText;
		const itemId = rule?.rule?.itemId;
		if (isNonEmptyString(itemText)) {
			return ` = ${itemText}`;
		} else if (customLabels[itemId]) {
			return ` = ${customLabels[itemId]}`;
		}

		return "";
	};

	const getRuleLabel = rule => {
		return rule.rule.label ? rule.rule.label : "";
	}

	return (
		<>
			{displayRules && displayRules.map((rule, index) => {
				const label = `${getRuleLabel(rule)}${getItemLabel(rule)}`;

				return (
					<Grid key={index}>
						<Grid.Row columns={16} className={styles.row}>
							<Grid.Column width={1} className={styles.letter}>
								<strong>{rule.letter}.</strong>
							</Grid.Column>
							<Grid.Column width={13}>
								<span>{label}</span>
							</Grid.Column>
							<Grid.Column width={1} className={`${styles.delete} ${styles.iconButtonWrapper}`}>
								<CommonButton className={styles.deleteButton} onClick={() => removeRuleFromGroup(index)} aria-label="Remove rule from group">
									<Icon name="trash" size="bigger" className={styles.pointer} />
								</CommonButton>
							</Grid.Column>
							{index === displayRules.length - 1 && (
								<Grid.Column width={1} className={`${styles.plus} ${styles.iconButtonWrapper}`}>
									<CommonButton className={styles.addButton} onClick={openModalAssignGroupNumber} aria-label="Add rule to this group">
										<Icon name="plus" size="bigger" className={styles.pointer} />
									</CommonButton>
								</Grid.Column>
							)}
						</Grid.Row>
						{index < (displayRules.length - 1) && (
							<Grid.Row columns={16} className={styles.row}>
								<Grid.Column width={16} className={styles.and}>
									<strong>{dictionary.and}</strong>
								</Grid.Column>
							</Grid.Row>
						)}
					</Grid>
				);
			})}
		</>
	);
};

export default RuleGroup;
